<form *ngIf="mainFormGroup" [formGroup]="mainFormGroup" #scrollToTop>
  <ng-container [formGroupName]="currentPage">
    <ng-container
      *ngIf="pages && (!skipPage || (skipPage && !skipPage[currentPage]))"
    >
      <bepatient-question-v3
        *ngFor="let question of pages[currentPage].questions"
        [id]="'question-' + question.key"
        [class]="
          question.type === 'hidden' ? 'bepatient-input-hidden-question' : ''
        "
        [color]="color"
        [ngClass]="question.customClasses.join(' ')"
        [question]="question"
        [formGroup]="mainFormGroup.controls[currentPage]"
        [readonly]="readonly"
        [class.readonly]="readonly"
        [isLoadingForm]="isLoadingForm"
      >
      </bepatient-question-v3>
    </ng-container>
  </ng-container>
</form>
